<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8" class="mx-auto">
        <v-card color="accent" dark elevation="14">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">Water Tank</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-card-text>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <WaterTank :waterTank="waterTank" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-simple-table style="background-color: #384263">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>Litres:</td>
                        <td>
                          {{ waterTank.TankLitres }}L
                          <v-chip
                            small
                            class="ml-2"
                            outlined
                            color="orange"
                            text-color="white"
                          >
                            {{ waterTank.Tankpercent }}%
                          </v-chip>
                        </td>
                      </tr>
                      <tr>
                        <td>Water Temperature:</td>
                        <td>{{ waterTank.WaterTemperature }}°C</td>
                      </tr>
                      <tr>
                        <td>Water Pump:</td>
                        <td>{{ waterTank.WaterPump }}</td>
                      </tr>
                      <tr>
                        <td>Valve Drippers:</td>
                        <td>{{ waterTank.valveDrippers }}</td>
                      </tr>
                      <tr>
                        <td>Valve 1:</td>
                        <td>{{ waterTank.valve1 }}</td>
                      </tr>
                      <tr>
                        <td>Valve 2:</td>
                        <td>{{ waterTank.valve2 }}</td>
                      </tr>
                      <tr>
                        <td>Valve 3:</td>
                        <td>{{ waterTank.valve3 }}</td>
                      </tr>
                      <tr>
                        <td>Valve 4:</td>
                        <td>{{ waterTank.valve4 }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import WaterTank from "@/components/WaterTank";

export default {
  components: {
    WaterTank,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      waterTank: (state) => state.mill.waterTank,
    }),
  },
  mounted() {
    this.$store.dispatch("fetchWaterTank");
  },
};
</script>
